module.exports = __webpack_public_path__ + "img/process.d6ffadce.png";